import store from '@/store';
import { Handle } from '../handles';
import Element from '../element';
import { Vector2, Vector3 } from '@babylonjs/core';
import { handlesManager } from '../handlesManager';
import { positionManager } from '../positionManager';
import { BaseCommand } from './baseCommand';
import { ShaderNull } from '../shaders/shader_null';

export class AddHandlesToFrontCommand extends BaseCommand {

    constructor(
        private front: Element,
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public execute(): void {
        const handle = store.getters.shaders.selectedHandle as Handle;
        if (handle.shader instanceof ShaderNull) { return; }
        const model = handle.model;
        const light = handle.light;
        const position = this.front.position.clone();
        const shape = Vector2.Zero();
        const helpPoints = handlesManager.getHelpPoints(this.front);
        helpPoints.forEach((helpPoint) => {
            this.scenePreview.addElement(model, light, handle.shader, position, shape, (x: Element) => {
                x.bind(this.front);
                this.elements.push(x);
                positionManager.positionWithParent(x, this.front.center, helpPoint);
                if (!helpPoint.isVertical && handle.isLong) {
                    x.rotate(90, new Vector3(0, 0, 1));
                }
            });
        });
    }
}
